module.exports = __webpack_public_path__ + "asset/image/promo-pack-background-2c47.png";